import { render } from "./ContactPhone.vue?vue&type=template&id=6ebc7300"
import script from "./ContactPhone.vue?vue&type=script&lang=js"
export * from "./ContactPhone.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__